var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-overlay"},[_c('spinner',{attrs:{"line-fg-color":"#313942","line-bg-color":"#eee","message":"Loading application..","spacing":10}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }